import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

const initialState = false;

export const dialogEmailOpenSlice = createSlice({
 name: 'dialogEmailOpen',
 initialState,
 reducers: {
  dialogEmailOpen: (state, action: PayloadAction<boolean>) => {
   state = action.payload;
   return state;
  },
 },
});

export const { dialogEmailOpen } = dialogEmailOpenSlice.actions;

export default dialogEmailOpenSlice.reducer;
